import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { DialogTitle, IconButton, DialogActions } from "@mui/material"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import TokenContext from "../../context/TokenContext"
import { obtenerUniversidades } from "../../Redux/autocompletados"
import { UserAuth } from "../../context/AuthContext"
import CustomSelect from "../CustomSelect"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"
import CustomDateField from "../CustomDateField"

const ModalCientificas = ({ open, handleClose, onSubmit }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const { empleado } = UserAuth()


    const defaultValues = {
        new_name: '',
        new_evento: '',
        new_lugar: '',
        new_formadeparticipacin: '',
        new_fecha: '',
    }

    const validacionSchema = yup.object().shape({
        new_name: yup.string().required("Required"),
        new_evento: yup.string().required("Required"),
        new_lugar: yup.string().required("Required"),
        new_formadeparticipacin: yup.number().required("Required"),
        new_fecha: yup.string().required("Required"),
    })

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }

    const opcionesForma = [
        { label: 'Asistencia', value: 100000000 },
        { label: 'Exposición', value: 100000001 },
        { label: 'Panelista', value: 100000002 },
        { label: 'Conferencista Invitado', value: 100000003 },
        { label: 'Moderación', value: 100000004 },
        { label: 'Redacción de Memorias', value: 100000005 },
        { label: 'Evaluación y Selección de Trabajos', value: 100000006 },
        { label: 'Organización y Coordinación', value: 100000007 },
        { label: 'Dirección', value: 100000008 },
        { label: 'Otra', value: 100000009 },
    ]


    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Crear participación en reuniones científicas o eventos artísticos</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_name"
                                label="Título"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el título."
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_evento"
                                label="Evento"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el evento."
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_lugar"
                                label="Lugar"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el lugar."
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_formadeparticipacin"
                                label="Forma de participación"
                                helperText="Por favor seleccione un valor"
                                options={opcionesForma}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={12} item sx={{ mt: 2 }}>
                            <CustomDateField
                                name="new_fecha"
                                label="Fecha:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha"
                                req={true}
                                className="custom-helper"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Crear</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalCientificas